import { matchPath } from "react-router-dom";

/** More specific paths must appear before general ones. */
const PAGE_TITLE_ROUTES = [
  // Public forms
  { path: "/client/intake/:token", title: "Client Intake Form" },
  { path: "/client/details/:slug", title: "Client Details Form" },
  { path: "/client/pr-enquiry/:slug", title: "PR Pathway Enquiry" },
  { path: "/client/check-in/:slug", title: "Office Check-in" },
  { path: "/referral/onboarding/:token", title: "Referral Partner Onboarding" },
  { path: "/partner/clients/:clientId", title: "Partner Client" },
  { path: "/partner/clients", title: "Partner Clients" },
  { path: "/partner/dashboard", title: "Partner Dashboard" },
  { path: "/partner/documents/:requestId", title: "Partner Document Request" },
  { path: "/partner/documents", title: "Partner Documents" },
  { path: "/partner/leads", title: "Partner New Clients" },
  { path: "/partner/price-list", title: "Partner Price List" },
  { path: "/partner/check-list", title: "Partner Check List" },
  { path: "/partner/courses", title: "Partner Courses" },
  { path: "/partner/appointments", title: "Partner Appointments" },
  { path: "/partner/payments", title: "Partner Payments" },
  { path: "/partner/alerts", title: "Partner Alerts" },
  { path: "/partner/settings", title: "Partner Settings" },
  { path: "/partner/help", title: "Partner Help" },
  { path: "/partner/training", title: "Partner Training" },
  { path: "/partner", title: "Partner Portal" },

  // Auth
  { path: "/register", title: "Register" },
  { path: "/forgot", title: "Forgot Password" },
  { path: "/reset/password/:token", title: "Reset Password" },
  { path: "/email/verify/", title: "Verify Email" },
  { path: "/employee/clock-in", title: "Employee Clock In" },
  { path: "/login", title: "Login" },

  // Admin — clients
  { path: "/admin/client/check-in/view/:id", title: "View Check-in" },
  { path: "/admin/client/check-in", title: "Check-in Data" },
  { path: "/admin/client/pr-enquiries", title: "PR Enquiries" },
  { path: "/admin/client/pr-enquiries/:id", title: "PR Enquiry" },
  { path: "/admin/client/archived", title: "Archived Clients" },
  { path: "/admin/client/duplicate", title: "Duplicate Clients" },
  { path: "/admin/client/add", title: "Add Client" },
  { path: "/admin/client/edit/:id", title: "Edit Client" },
  { path: "/admin/client/view/:id", title: "View Client" },
  { path: "/admin/client", title: "Clients" },

  // Admin — accounts
  { path: "/admin/account/provider/add", title: "Add Provider" },
  { path: "/admin/account/add", title: "Add Account" },
  { path: "/admin/account", title: "Accounts" },
  { path: "/admin/profit-loss", title: "Profit & Loss" },

  // Admin — referrals
  { path: "/admin/admin-referral/:id/clients/:clientId", title: "Referral Entries" },
  { path: "/admin/admin-referral/:id/clients", title: "Referral Clients" },
  { path: "/admin/admin-referral/program", title: "Partner Program Content" },
  { path: "/admin/admin-referral/referrer-review", title: "Referrer review" },
  { path: "/admin/referral/clients", title: "Referral Clients" },
  { path: "/admin/admin-referral", title: "Partners" },
  { path: "/admin/admin-referral/partners/:id", title: "Referral Partner" },
  { path: "/admin/referral/referred-clients", title: "Referred Clients" },

  // Admin — tasks
  { path: "/admin/tasks/view/:id", title: "View Task" },
  { path: "/admin/tasks/add", title: "Add Task" },
  { path: "/admin/tassk/edit/:id", title: "Edit Task" },
  { path: "/admin/tasks", title: "Tasks" },

  // Admin — timesheets
  { path: "/admin/timesheets/edit/:id", title: "Edit Employee" },
  { path: "/admin/timesheets/view/:id", title: "Employee Timesheet" },
  { path: "/admin/timesheets/add", title: "Add Employee" },
  { path: "/admin/timesheets", title: "Timesheets" },

  // Admin — university
  { path: "/admin/university/:uniId/course/edit/:courseId", title: "Edit University Course" },
  { path: "/admin/university/:uniId/course/add", title: "Add University Course" },
  { path: "/admin/university/edit/:id", title: "Edit University" },
  { path: "/admin/university/add", title: "Add University" },
  { path: "/admin/university/report", title: "College Admission Summary" },
  { path: "/admin/university", title: "Universities" },

  // Admin — admissions
  { path: "/admin/admission/fees/:id", title: "Admission Fees" },
  { path: "/admin/admission/client/:clientId", title: "Client Admissions" },
  { path: "/admin/admission/edit/:id", title: "Edit Admission" },
  { path: "/admin/admission/add", title: "Add Admission" },
  { path: "/admin/admission/view", title: "Admission Details" },
  { path: "/admin/admission", title: "Admissions" },

  // Admin — consultancy
  { path: "/admin/consultancy/view/:id", title: "View Consultancy" },
  { path: "/admin/consultancy/edit/:id", title: "Edit Consultancy" },
  { path: "/admin/consultancy/add", title: "Add Consultancy" },
  { path: "/admin/consultancy", title: "Consultancies" },

  // Admin — visa
  { path: "/admin/visa/client/:clientId", title: "Client Visa Applications" },
  { path: "/admin/visa/edit/:id", title: "Edit Visa" },
  { path: "/admin/visa/add", title: "Add Visa" },
  { path: "/admin/visa", title: "Visa" },

  // Admin — skill assessment
  { path: "/admin/skill-assessment/client/:clientId", title: "Client Skill Assessments" },
  { path: "/admin/skill-assessment/edit/:id", title: "Edit Skill Assessment" },
  { path: "/admin/skill-assessment/add", title: "Add Skill Assessment" },
  { path: "/admin/skill-assessment", title: "Skill Assessment" },

  // Admin — RPL
  { path: "/admin/rpl-client/client/:clientId", title: "Client RPL Certificates" },
  { path: "/admin/rpl-client/edit/:id", title: "Edit RPL Client" },
  { path: "/admin/rpl-client/add", title: "Add RPL Client" },
  { path: "/admin/rpl-client", title: "RPL Clients" },
  { path: "/admin/rpl-course/view/:id", title: "View RPL Course" },
  { path: "/admin/rpl-course/add", title: "Add RPL Course" },
  { path: "/admin/rpl-course", title: "RPL Courses" },

  // Admin — courses
  { path: "/admin/course/edit/:id", title: "Edit Course" },
  { path: "/admin/course/add", title: "Add Course" },
  { path: "/admin/course", title: "Courses" },

  // Admin — users
  { path: "/admin/user/view/:id", title: "View User" },
  { path: "/admin/user/edit/:id", title: "Edit User" },
  { path: "/admin/user/add", title: "Add User" },
  { path: "/admin/user", title: "Users" },

  // Admin — invoices
  { path: "/admin/invoice/view/:id", title: "View Invoice" },
  { path: "/admin/invoice/edit/:id", title: "Edit Invoice" },
  { path: "/admin/invoice/salary-payslip", title: "Salary Payslip" },
  { path: "/admin/invoice/add", title: "Add Invoice" },
  { path: "/admin/invoice", title: "Invoices" },

  // Admin — follow-up
  { path: "/admin/follow-up/view/:clientId/:followUpId", title: "Follow-up Details" },
  { path: "/admin/follow-up", title: "Follow-up" },

  // Admin — settings & misc
  { path: "/admin/settings/other", title: "Other Settings" },
  { path: "/admin/settings", title: "Settings" },
  { path: "/admin/setting", title: "Settings" },
  { path: "/admin/preferences", title: "Preferences" },
  { path: "/admin/profile", title: "Profile" },
  { path: "/admin/change/password/", title: "Change Password" },
  { path: "/admin/emails/compose", title: "Compose Message" },
  { path: "/admin/emails", title: "Messages" },
  { path: "/admin/intake-forms", title: "Intake Forms" },
  { path: "/admin/appointments", title: "Appointments" },
  { path: "/admin/reminders", title: "Reminders" },
  { path: "/admin/notifications", title: "Notifications" },
  { path: "/admin/price-list", title: "Price List" },
  { path: "/admin/check-list", title: "Check List" },
  { path: "/admin/insurance/client/:clientId", title: "Client Insurance Policies" },
  { path: "/admin/insurance", title: "Insurance" },
  { path: "/admin/insurance/add", title: "Add Insurance" },
  { path: "/admin/insurance/edit/:id", title: "Edit Insurance" },
  { path: "/admin/dashboard", title: "Dashboard" },
  { path: "/admin", title: "Dashboard" },
  { path: "/change/password", title: "Change Password" },
  { path: "/", title: "Login" },
];

export const getPageTitleForPath = (pathname) => {
  const match = PAGE_TITLE_ROUTES.find(({ path }) => matchPath({ path, end: true }, pathname));

  return match?.title ?? null;
};
